import React from "react";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import PeopleIcon from "@mui/icons-material/People";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PolicyIcon from "@mui/icons-material/Policy";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import { SidebarItem } from "./types/SidebarTypes";
import qs from "qs";

export const SIDEBAR_ITEMS: SidebarItem[] = [
  {
    text: "Pagrindinis",
    to: "/",
    adminOnly: false,
    exact: true,
    icon: React.createElement(HomeIcon)
  },
  {
    text: "Vadybininkai",
    to: "/managers",
    adminOnly: true,
    icon: React.createElement(PeopleIcon)
  },
  {
    text: "Statistika",
    to: "/statistics",
    adminOnly: true,
    icon: React.createElement(AssessmentIcon)
  },
  {
    text: "Prisijungimai",
    to: "/rules",
    adminOnly: true,
    icon: React.createElement(PolicyIcon)
  },
  {
    text: "Laiškai",
    to: "/email-statistics",
    adminOnly: true,
    icon: React.createElement(AllInboxIcon)
  },
  {
    text: "Klientai",
    to: "/clients?myClients=false",
    adminOnly: false,
    isActive: (_, location) => {
      const isCorrectParam =
        qs.parse(location.search, { ignoreQueryPrefix: true }).myClients === "false";
      return isCorrectParam && location.pathname.startsWith("/client");
    },
    icon: React.createElement(AccountBoxIcon)
  },
  {
    text: "Mano Klientai",
    to: "/clients?myClients=true",
    adminOnly: false,
    isActive: (_, location) => {
      const isCorrectParam =
        qs.parse(location.search, { ignoreQueryPrefix: true }).myClients === "true";
      return isCorrectParam && location.pathname.startsWith("/client");
    },
    icon: React.createElement(AccountBoxIcon)
  },
  {
    text: "Paštas",
    to: "/emails",
    adminOnly: false,
    icon: React.createElement(EmailIcon)
  },
  {
    text: "Sąskaitos",
    to: "/invoices",
    adminOnly: false,
    icon: React.createElement(CreditCardIcon)
  }
]; 